export default __webpack_public_path__ + "static/media/ScreenShot_2.5f75f057.jpg";